import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import CustomSelect from '../../../../widgets/CustomSelect/CustomSelect';
import FormSubsection from '../../../../widgets/FormSubsection/FormSubsection';
import {
  containsMutableField,
  PRODUCT_LINE_ITEM_FIELDS
} from '../line-item-page-util';
import { injectIntl } from 'react-intl';

class ProductLineItemHeader extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      disabled: true
    };

    this.toggleDisabled = this.toggleDisabled.bind(this);
  }

  toggleDisabled() {
    this.setState({
      disabled: !this.state.disabled
    });
  }

  render() {
    const deliveryFreqOptions = this.props.deliveryFrequencies.map(
      (frequency) => ({
        value: frequency.deliverySchemeCode,
        label: frequency.description
      })
    );

    const deliveryFrequencyName =
      PRODUCT_LINE_ITEM_FIELDS.deliveryFrequency.name;

    const mutableFields = {
      [deliveryFrequencyName]: this.props.isFieldEditable(
        deliveryFrequencyName,
        this.props.lineItem
      )
    };

    return (
      <FormSubsection
        title="General"
        disabled={this.state.disabled}
        toggleDisabled={this.toggleDisabled}
        showEdit={containsMutableField(mutableFields) && !this.props.disabled}
      >
        <div className="row field-container">
          <div
            className="
              col-xs-12
              col-sm-3
              padding-wrapper"
          >
            <Typography type="body2" gutterBottom align="left">
              {this.props.intl.formatMessage({
                id: 'description'
              })}
            </Typography>
            {this.props.lineItem.itemName}
          </div>
          <div
            className="
              col-xs-12
              col-sm-3
              padding-wrapper"
          >
            <Typography type="body2" gutterBottom align="left">
            {this.props.intl.formatMessage({
                id: 'code'
              })}
            </Typography>
            {this.props.lineItem.itemCode}
          </div>
          <div
            className="
              col-xs-12
              col-sm-3
              padding-wrapper"
          >
            <Typography type="body2" gutterBottom align="left">
            {this.props.intl.formatMessage({
                id: 'size'
              })}
            </Typography>
            {this.props.lineItem.size}
          </div>
          <div
             className="
               col-xs-12
               col-sm-3
               padding-wrapper"
           >
             <CustomSelect
               labelText={'Frequency'}
               disabled={
                 this.state.disabled ||
                 this.props.disabled ||
                 !mutableFields[deliveryFrequencyName]
               }
               handleChange={(value) => {
                 const lineItem = PRODUCT_LINE_ITEM_FIELDS[
                   deliveryFrequencyName
                 ].getUpdatedLineItem(this.props.lineItem, value);
                 this.props.handleChangeLineItem(lineItem);
               }}
               options={deliveryFreqOptions}
               originalValue={this.props.lineItem[deliveryFrequencyName]}
               baseValue={this.props.lineItem[deliveryFrequencyName]}
               selectedValue={this.props.lineItem[deliveryFrequencyName]}
               disableCustomOption
             />
           </div>
        </div>
      </FormSubsection>
    );
  }
}

ProductLineItemHeader.propTypes = {
  lineItem: PropTypes.object,
  handleChangeLineItem: PropTypes.func,
  isFieldEditable: PropTypes.func,
  deliveryFrequencies: PropTypes.array,
  disabled: PropTypes.bool
};

export default injectIntl(ProductLineItemHeader);
